import Vue from 'vue';

export function getUserData(): any {
    const userData = sessionStorage.getItem('userData');
    if (userData) {
        return JSON.parse(userData);
    } else return {};
}

export function checkUserRole(): string {
    let userRole = '';
    //const userData = sessionStorage.getItem('userData');
    const userData = Vue.auth.user();
    /*const cRoles: string[] = [];
    if (userData !== null && userData.length > 1) {
        const Data = JSON.parse(userData);
        Data.roles.forEach((role: any) => {
            cRoles.push(role.code);
            userRole = role.code;
        });
        Data.CompleteRoles = cRoles;
        //Vue.auth.user(Data);
    }*/
    if(userData && userData.CompleteRoles && userData.CompleteRoles.length) {
        userRole = userData.CompleteRoles['0'];
    }

    return userRole;
}
